export enum REGIMES_TYPE {
	PLATAFORMAS_TECNOLOGICAS = 'Plataformas Tecnológicas',
	SUELDOS_Y_SALARIOS = 'Sueldos y Salarios',
	RESICO = 'RESICO',
	ARRENDAMIENTO = 'Arrendamiento',
	ACTIVIDAD_EMPRESARIAL = 'Actividades Empresariales y Profesionales',
	RIF = 'RIF',
	OTRO = 'Otro',
}

export enum REGIMES_LONG_TYPE {
	PLATAFORMAS_TECNOLOGICAS = 'Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas',
	SUELDOS_Y_SALARIOS = 'Sueldos y Salarios e Ingresos Asimilados a Salarios',
	RESICO = 'Régimen Simplificado de Confianza',
	ARRENDAMIENTO = 'Arrendamiento',
	ACTIVIDAD_EMPRESARIAL = 'Personas Físicas con Actividades Empresariales y Profesionales',
	RIF = 'Incorporación Fiscal',
}

export enum REGIMES_CODE {
	PLATAFORMAS_TECNOLOGICAS = '625',
	SUELDOS_Y_SALARIOS = '605',
	RESICO = '626',
	ARRENDAMIENTO = '606',
	ACTIVIDAD_EMPRESARIAL = '612',
	GENERAL_LEY_PERSONAS_MORALES = '601',
	PERSONAS_MORALES_CON_FINES_NO_LUCRATIVOS = '603',
	RESIDENTES_EN_EXTRAJERO_SIN_ESTABLECIMIENTO_EN_MEXICO = '610',
	RIF = '621',
}

export enum REGIMES_SHORT_NAME {
	PLATEC = 'platec',
	RESICO = 'resico',
	LEASE = 'lease',
	RIF = 'rif',
	BUSINESS = 'business',
}

export const SHORT_REGIME_NAME: Record<number, string> = {
	626: 'RESICO',
	603: 'Persona moral con fines no lucrativos',
	610: 'Residente en el extranjero sin establecimiento',
	616: 'Sin obligaciones fiscales',
	628: 'Hidrocarburos',
	609: 'Consolidación',
	613: 'Enajenación de acciones en bolsa de valores',
	608: 'Demás ingresos',
	607: 'Enajenación o Adquisición de Bienes',
	623: 'Opcional para grupos de sociedades',
	606: 'Arrendamiento',
	612: 'Actividad empresarial',
	601: 'General de ley personas morales',
	605: 'Sueldos y salarios',
	621: 'RIF',
	625: 'Plataformas Tecnológicas',
	622: 'Actividades agrícolas',
	611: 'Ingresos por dividendos',
};
